import React from 'react';
import { Route } from 'react-router-dom';
import { NavItem } from 'react-bootstrap';

const isRouteActive = (match, location, href) => {
  if (match) return true;
  if (href === '/') return false;
  if (location.pathname.indexOf(href) !== -1) return true;
  return false;
};

export default props => (
  <Route
    path={props.href}
    exact
    children={({ match, history, location }) => {
      return (
        <NavItem
          onClick={e => history.push(e.currentTarget.getAttribute('href'))}
          {...props}
          active={isRouteActive(match, location, props.href)}
        >
          {props.children}
        </NavItem>
      );
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/RouteNavItem.js